export const MANUAL_VALUE = 'manual_fund';
export const MANUAL_LABEL = `Can't find fund? Enter manually`;

export const MANUAL_FUND_OPTION = {
	value: MANUAL_VALUE,
	label: MANUAL_LABEL,
};

export const SB_FAIL = 'fail';
